import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { editContent } from "../../modules/editor";
import produce from 'immer';

import FieldSection from './FieldSection';
import SelectedContentShopProduct from './SelectedContentShopProduct';
import Select from '../../components/Dropdown/Select';

import CheckIcon from '../../components/Icon/CheckIcon';
import backButton from '../../assets/images/icon/btn-back.png';
import ShopsDropdown from '../../components/Dropdown/ShopsDropdown';
import { Shop } from '../../modules/editor';

const shopTypeOptions = [
	{name: '1단 세로', value: 'shopA'},
	{name: '1단 가로', value: 'shopB'},
	{name: '2단', value: 'shopC'}
]

type Props = {
	selectedContentId: number;
	currentContent: any;
}

function SelectedContentShop({ selectedContentId, currentContent }: Props) {
	const shops = useSelector((state: RootState) => state.editor.shops);
	const defaultShop = useSelector((state: RootState) => state.editor.defaultShop);
	const isCafe24Workspace = useSelector((state: RootState) => state.auth.account.from) === 'CAFE24' || useSelector((state: RootState) => state.auth.account.from) === 'IMWEB';
    const isSixshopWorkspace = useSelector((state: RootState) => state.auth.account.from) === 'SIXSHOP';

	const [shopType, setShopType] = useState('shopA');
	const [cards, setCards] = useState([
		{name: '상품 이미지', value:'image'},
		{name: '상품 이름', value:'text'},
		{name: '정상가', value:'text'},
		{name: '할인가', value:'text'},
		{name: '상품 설명', value:'text'},
		{name: '버튼', value:'cta'},
	])
	const [showDetailSetting, setShowDetailSetting] = useState(false);
	const [selectedShop, setSelectedShop] = useState<Shop>(defaultShop);

	useEffect(() => {
		setSelectedShop(defaultShop);
	}, [defaultShop]);

	const dispatch = useDispatch();

	useEffect(() => {
		setShopType(currentContent?.content?.type);
	}, [currentContent]);

	const onToggleProperty = (index:number, subIndex:number) => {
		const newValue = produce(currentContent?.content?.column, (draft:any) => {
			if (draft[index][subIndex].includes('_hide')) {
				draft[index][subIndex] = draft[index][subIndex].replace('_hide', '');
			} else {
				draft[index][subIndex] = `${draft[index][subIndex]}_hide`;
			}
		});		

		dispatch(editContent({ target: `${selectedContentId}/column`, data: newValue }));
	}

	return (
		<div className="editor-sidebar-selected-content-setting">

			<FieldSection
				labelName=""
				label={false}
				fullWidth={true}
			>
				<div style={{paddingTop:'15px'}}>
					<button
						className={(isCafe24Workspace || isSixshopWorkspace) ? 'btn medium' : 'btn disabled bordered'}
						onClick={() => {setShowDetailSetting(true)}}
					>
						상품 설정하기
					</button>
				</div>
			</FieldSection>

			<h3 className="field-section-title">레이아웃</h3>
			<FieldSection
				labelName=""
				label={false}
			>
				<Select 
					target={`${selectedContentId}/type`}
					value={shopType}
					options={shopTypeOptions}
					size="full"
				/>
			</FieldSection>			

			<div className={showDetailSetting ? 'editor-sidebar-selected-content active' : 'editor-sidebar-selected-content'}>
				<header className="selected-content-header">
					<h2>
						<button onClick={() => {setShowDetailSetting(false)}}>
							<img src={backButton} alt="back" width="42"/>
						</button>
						상품 설정하기
					</h2>
				</header>

        {isCafe24Workspace && (
          <>
            <h3 className="field-section-title">쇼핑몰</h3>
            <FieldSection labelName='쇼핑몰' label={false}>
              <ShopsDropdown
                shops={shops}
                selectedShop={selectedShop}
                setSelectedShop={setSelectedShop}
                />
            </FieldSection>
          </>
        )}
				{
				currentContent?.content.type === 'shopA' && (
					<>
					<h3 className="field-section-title">상품</h3>
					<SelectedContentShopProduct 
						target={`${selectedContentId}/content/0`}
						shopType={currentContent?.content?.type}
						selectedShop={selectedShop}
					/>
					<FieldSection
						labelName=""
						label={false}
					>
						<div className="field-type-toggle">
							{
								cards.map((item:any, subIndex:number) => (
									<button 
										key={subIndex}
										onClick={() => { onToggleProperty(0, subIndex)}}
									>
										<CheckIcon checked={currentContent?.content?.column[0][subIndex] === item.value} />
										{item.name}
									</button>
								))
							}
						</div>
					</FieldSection>
					</>
				)
				}

				{
				currentContent?.content.type === 'shopB' && (
					<>
						<h3 className="field-section-title">상품</h3>
						<SelectedContentShopProduct 
							target={`${selectedContentId}/content/0`}
							shopType={currentContent?.content?.type}
							selectedShop={selectedShop}
						/>
						<FieldSection
							labelName=""
							label={false}
						>							
							<div className="field-type-toggle">
								{
									cards.map((item:any, subIndex:number) => (
										<button 
											key={subIndex}
											onClick={() => { onToggleProperty(0, subIndex)}}
											className={item.value !== 'image' ? 'blind' : ''}
										>
											<CheckIcon checked={currentContent?.content?.column[0][subIndex] === item.value} />
											{item.name}
										</button>
									))
								}
								{
									cards.map((item:any, subIndex:number) => (
										<button 
											key={subIndex}
											onClick={() => { onToggleProperty(1, subIndex)}}
											className={item.value === 'image' ? 'blind' : ''}
										>
											<CheckIcon checked={currentContent?.content?.column[1][subIndex] === item.value} />
											{item.name}
										</button>
									))
								}
							</div>
						</FieldSection>
					</>
				)
				}

				{
				currentContent?.content.type === 'shopC' && (
					<>
						<h3 className="field-section-title">왼쪽 상품</h3>
						<SelectedContentShopProduct
							target={`${selectedContentId}/content/0`}
							shopType={currentContent?.content?.type}
							selectedShop={selectedShop}
						/>
						<FieldSection
							labelName=""
							label={false}
						>
							<div className="field-type-toggle">
								{
									cards.map((item:any, subIndex:number) => (
										<button
											key={subIndex}
											onClick={() => { onToggleProperty(0, subIndex)}}
										>
											<CheckIcon checked={currentContent?.content?.column[0][subIndex] === item.value} />
											{item.name}
										</button>
									))
								}
							</div>
						</FieldSection>
						<h3 className="field-section-title">오른쪽 상품</h3>
						<SelectedContentShopProduct
							target={`${selectedContentId}/content/1`}
							shopType={currentContent?.content?.type}
							selectedShop={selectedShop}
						/>
						<FieldSection
							labelName=""
							label={false}
						>

							<div className="field-type-toggle">
								{
									cards.map((item: any, subIndex: number) => (
										<button
											key={subIndex}
											onClick={() => { onToggleProperty(1, subIndex) }}
										>
											<CheckIcon checked={currentContent?.content?.column[1][subIndex] === item.value} />
											{item.name}
										</button>
									))
								}
							</div>
						</FieldSection>
					</>
				)
				}
			</div>

		</div>
	);
}

export default SelectedContentShop;
